import { SWReactIcons } from "@similarweb/icons";
import type { FunctionComponent } from "react";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { setFont } from "@similarweb/styles";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

export const IconWithTextCell = styled(SWReactIcons)`
    height: 16px;
    width: 16px;
    margin-left: 4px;
    line-height: 16px;
`;

const IconWithTextWrapper = styled.div`
    display: flex;
    height: 16px;
    align-items: center;
`;
export const HighestLowestLabel = styled.span`
    margin-left: 4px;
    ${setFont({
        $color: colorsPalettes.carbon[250],
        $size: 12,
        $weight: 500,
        $family: "'Roboto'",
    })};
`;

export const CellWrapper = styled.span<{ isLeader: boolean }>`
    margin-left: 11px;
    display: flex;
    align-items: center;
    font-weight: ${({ isLeader }) => (isLeader ? 700 : 500)};
    ${setFont({
        $color: colorsPalettes.carbon[400],
        $size: 20,
        $family: "DM Sans",
    })};
`;

interface ILeadersHighestLowestCellProps {
    value: ILeadersHighestLowestCellItem;
    format?: any;
}

interface ILeadersHighestLowestCellItem {
    Value: any;
    format?: any;
    IsLeader: boolean;
    IsHighest: boolean;
    IsLowest: boolean;
}

export const LeadersHighestLowestCell: FunctionComponent<ILeadersHighestLowestCellProps> = (props) => {
    const { value, format } = props;
    const realValue = value.Value;
    const isLeader = value.IsLeader && !!realValue && realValue > 0;
    const isHighest = value.IsHighest && !!realValue && realValue > 0;
    const isLowest = value.IsLowest && !!realValue && realValue > 0;
    const cellFormat = format ? format : value?.format;
    const translate = useTranslation();

    return (
        <CellWrapper isLeader={isLeader}>
            {realValue === null ? "N/A" : cellFormat(realValue)}
            {isHighest ? (
                <IconWithTextWrapper>
                    <IconWithTextCell
                        iconName="arrow-up-grey"
                        size="xs"
                    />
                    <HighestLowestLabel>{translate("common.highest")}</HighestLowestLabel>
                </IconWithTextWrapper>
            ) : null}
            {isLowest ? (
                <IconWithTextWrapper>
                    <IconWithTextCell
                        iconName="arrow-down-grey"
                        size="xs"
                    />
                    <HighestLowestLabel>{translate("common.lowest")}</HighestLowestLabel>
                </IconWithTextWrapper>
            ) : null}
            {isLeader ? <IconWithTextCell iconName="winner" /> : null}
        </CellWrapper>
    );
};
